import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CloApplicationTray, CloApplicationTrayItem} from './application-tray';


export {CloApplicationTray, CloApplicationTrayItem} from './application-tray';

@NgModule({
  declarations: [CloApplicationTray, CloApplicationTrayItem],
  exports: [CloApplicationTray, CloApplicationTrayItem],
  imports: [CommonModule],
  entryComponents: [CloApplicationTray]
})
export class CloApplicationTrayModule {
}
